import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Box, Card, CardContent, TextField, Button, Typography, Container, Alert
} from '@mui/material';
import { School } from '@mui/icons-material';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { token } = useParams();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    if (password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`/api/v1/auth/reset-password/${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password })
      });

      const data = await response.json();

      if (data.success) {
        setMessage('Password has been reset successfully!');
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      } else {
        setError(data.message || 'Failed to reset password. The link might be expired.');
      }
    } catch (err) {
      setError('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #1a2332 0%, #2c3e50 50%, #1a9e8f 100%)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Container maxWidth="sm" sx={{ position: 'relative', zIndex: 1 }}>
        <Card sx={{ borderRadius: '12px', boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)', border: 'none' }}>
          <Box sx={{ bgcolor: '#1a9e8f', py: 3, textAlign: 'center' }}>
            <School sx={{ fontSize: 48, color: '#fff', mb: 1 }} />
            <Typography variant="h5" sx={{ color: '#fff', fontWeight: 700 }}>VP School MIS</Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.8)' }}>Set New Password</Typography>
          </Box>

          <CardContent sx={{ p: 4 }}>
            {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}
            {message && <Alert severity="success" sx={{ mb: 3 }}>{message}</Alert>}

            {!message && (
              <form onSubmit={handleSubmit}>
                <TextField
                  fullWidth label="New Password" type="password" value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required margin="normal" autoFocus
                />
                
                <TextField
                  fullWidth label="Confirm Password" type="password" value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required margin="normal"
                />

                <Button
                  type="submit" fullWidth variant="contained" disabled={loading}
                  sx={{ mt: 3, mb: 2, py: 1.2, bgcolor: '#1a9e8f !important', fontWeight: 700 }}
                >
                  {loading ? 'Updating...' : 'Reset Password'}
                </Button>
              </form>
            )}
            
            <Box sx={{ mt: 2, textAlign: 'center' }}>
              <Button 
                variant="text" 
                onClick={() => navigate('/login')}
                sx={{ color: '#1a9e8f', textTransform: 'none', fontWeight: 600 }}
              >
                Back to Login
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default ResetPassword;
